module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_kobe-20440e8d5d771f778e8cb02bca52f230.jpg";